// extracted by mini-css-extract-plugin
module.exports = {"content":"CommonCardA_content__Iy_En"};